<template>
    <div>
        <DragWrapper :top="100" :left="100" :drag-ref="$refs.handle">

            <v-card v-if="ready" flat :width="width" class="mx-auto">

                    <v-system-bar color="primary" dark drag-handle :window="true">
                            <v-icon color="secondary">mdi-layers</v-icon>
                            <span>Layers</span>
                    </v-system-bar>
                    
                    <v-card-text v-if="loading">
                        <v-row justify="center">
                            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                        </v-row>
               
                    </v-card-text>

                    <v-card-text v-else>
                        <v-row justify="start">
                            <v-col>

                              <v-select
                                    item-text="name"
                                    item-value="value"
                                    value="OSM"
                                    :items="mainMap.backgroundLayers"
                                    label="Background"
                                    @change="(x) => mainMap.setBackgroundLayer(x)"
                                    style="max-height : 50px;"
                                    class="pt-2"
                                    background-color="white"
                                    dense
                                    color="secondary"
                                    item-color="secondary"
                                ></v-select>

                            </v-col>

                        </v-row>

                        <v-row><v-divider></v-divider></v-row>

                        <v-row justify="start">
                            
                            <v-col>

                                <v-select
                                    item-text="name"
                                    item-value="value"
                                    v-model="polarization"
                                    :items="tileServerClient.polarizations"
                                    label="Polarization"
                                    @change="refreshTileSource"
                                    style="max-height : 50px;"
                                    class="pt-2"
                                    background-color="white"
                                    dense
                                    color="secondary"
                                    item-color="secondary"
                                ></v-select>
                            </v-col>
                            <v-col>
                                <v-select
                                    :items="dates"
                                    v-model="date"
                                    label="Date"
                                    @change="refreshTileSource"
                                    style="max-height : 50px;"
                                    class="pt-2"
                                    background-color="white"
                                    dense
                                    color="secondary"
                                    item-color="secondary"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row justify="start">
                            <LayerVisibilityControl :layer="mainMap.tile"></LayerVisibilityControl>
                        </v-row>

                        <v-row><v-divider></v-divider></v-row>

                        <v-row justify="start">
                            <p class="text-subtitle-2 pl-2 pt-1 mb-0">
                                 Wetlands
                            </p>
                            <v-icon class="mx-2" :color="showFilters ? 'secondary' : 'primary'" @click="showFilters = !showFilters">mdi-filter</v-icon>
                        </v-row>
                        <v-row justify="start">
                            <LayerVisibilityControl :layer="mainMap.wetlandsGroup"></LayerVisibilityControl>
                        </v-row>


                    </v-card-text>

            </v-card>


        </DragWrapper>

        <FeatureProperties key="featureProperties" v-show="selectedFeature" :featuresLoading="featurePropertiesLoading" :featureProperties="selectedFeature ? selectedFeature.getProperties() : {}"></FeatureProperties>

        <FeatureFilter key="featureFilter" :show="showFilters" ref="filter" :map="mainMap"></FeatureFilter>
        
    </div>
</template>

<script>

import MainMap from '../classes/MainMap'
import DragWrapper from './common/DragWrapper.vue'
import LayerVisibilityControl from './common/LayerVisibilityControl.vue'
import FeatureProperties from './FeatureProperties.vue'
import FeatureFilter from './FeatureFilter.vue'
import GeoJSON from 'ol/format/GeoJSON';

export default {
  
    components: {
        DragWrapper,
        LayerVisibilityControl,
        FeatureProperties,
        FeatureFilter
    },

    inject: ['tileServerClient'],

    props: {
        width: {
            type: Number,
            default: 300,
        },
        height: {
            type: Number,
            default: 600,
        },
        mainMap: {
            type: MainMap,
            required: true,
        },

    },


    data: () => ({
        ready : false,

        dates : [],
        date : null,
        
        polarization : 'VV',

        selectedFeatureProperties : null,
        featurePropertiesLoading : true,

        wetlandsStats: {},

        selectedFeature : null,

        showFilters : false,

        loading : true,
        
    }),

    mounted() {

        // add handler for select interaction on map
        this.mainMap.selectInteraction.on('select', (e) => {

            this.selectedFeature = e.selected[0];
            this.mainMap.setSelectedFeature(this.selectedFeature);

            if(!this.selectedFeature)
                return;

            // sets select color
            this.$refs.filter.applyFilters();

        });

        this.ready = true;
        this.featurePropertiesLoading = true;

        // load dates from server
        this.tileServerClient.getDates()

            .then((r) => {

                this.dates = r.data;
                this.date = this.dates[0];

                this.tileServerClient.getWetlandsGeojson()
                    .then(r => {
                        
                        const formatter = new GeoJSON();
                        
                        this.features = formatter.readFeatures(r.data);
                        // this.wetlandsStats = r[1].data;

                        this.mainMap.addWetlandFeatures(this.features);
                        this.refreshTileSource();
                        this.loading = false;

                    })
            });

    },

    methods: {

        refreshTileSource() {
            
            this.featurePropertiesLoading = true;
            const url = this.tileServerClient.getTileSourceUrl(this.date, this.polarization);
            this.mainMap.refreshTileSource(url);

            this.tileServerClient.getWetlandsStats(this.date)
                .then(r => {

                    // join stats with features (stats change on if date changes)
                    this.joinFeatureStats(this.features, r.data);
                    this.wetlandsStats = r.data;
                    this.$refs.filter.applyFilters();

                    this.featurePropertiesLoading = false;
                })


        },



        joinFeatureStats(features, stats) {

            features.forEach(f => {
                
                let stat = stats.find(s => {
                    return s.id == f.values_['OBJECTID']; // getFeatureProperties works 2 slow
                });
                
                f.setProperties({
                    'stats' : stat
                }, true);
            })
        }
    }

};
</script>
